import { v4 as uuid } from 'uuid';

import { getChatbotActionButtons } from './getChatbotActionButtons';
import { setChatbotMessageSending } from '../../actions/chatbot/actions';
import { setMessagesFulfilled } from '../../actions/messages';
import { addTextMessageToChat, deleteMessageFromChat } from '../../actions/sendMessage';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { CHATBOT_PAYLOAD } from '../../constants/chatbotPayload';
import { chatbotSelector } from '../../selectors';
import { chatbotSendMessage } from '../../services/chatbotSendMessage';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';

export const sendChatbotMessage =
  (message: string, offerId?: number, messageId?: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { rowVersion, messageSending: isMessageSending } = chatbotSelector(getState());

    if (isMessageSending) {
      return;
    }

    const messageIdFromUuid = uuid();

    dispatch(setChatbotMessageSending(true));

    try {
      dispatch(addTextMessageToChat(message, CHATBOT_ID, messageIdFromUuid));

      const chatMessage = await chatbotSendMessage(context, {
        messageText: message,
        offerId,
        messageId,
        rowVersion,
      });

      /* istanbul ignore next*/
      if (!chatMessage) {
        dispatch(showAlert({ message: 'Не получилось, попробуйте ещё раз' }));
        dispatch(setChatbotMessageSending(false));

        return;
      }

      dispatch(
        deleteMessageFromChat({
          chatId: CHATBOT_ID,
          messageId: messageIdFromUuid,
          messagesMap: context.custom.messagesMap,
        }),
      );

      dispatch(
        setMessagesFulfilled({ messages: [chatMessage], chatId: CHATBOT_ID, messagesMap: context.custom.messagesMap }),
      );
      dispatch(getChatbotActionButtons(CHATBOT_PAYLOAD.SendMessage));
    } catch (error) {
      dispatch(setChatbotMessageSending(false));

      throw error;
    }
  };
